@if (user(); as user) {
  <mat-toolbar class="gap-2 border-bottom mat-elevation-z4 ps-5 z-3">
    @if (colorMode.currentMode() === 'dark') {
      <img src="/assets/img/logo-and-text-dark.png" alt="CRST Compass" width="190" height="54" />
    } @else {
      <img src="/assets/img/logo-and-text.png" alt="CRST Compass" width="190" height="54" />
    }
    @if (userSession(); as session) {
      <auth-customer-select [session]="session" />
      <cp-navigation class="mx-auto h-100" />
      <cp-account-manager [userSession]="session" />
      <cp-user-menu
        (logout)="logout()"
        (contactUs)="showContactUs.set(true)"
        (passwordReset)="navigateToPasswordReset()"
      />
    }
  </mat-toolbar>
  <http-loading />
  <ui-alert-banner [alerts]="alerts" />
}
<main class="h-100 overflow-auto">
  <router-outlet />
  <router-outlet name="details" />
</main>
<ui-side-drawer [(isOpen)]="showContactUs">
  <contact-us-sidebar *uiSideDrawerContent (contactClose)="showContactUs.set(false)" />
</ui-side-drawer>
